import { useQuery } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevineGroupApi } from '@/features/api/hooks/grapevine-group/useGrapevineGroupApi';
import { useAuth } from '@/features/authorization/provider/useAuth';

export const useGetGroupAdmins = (groupId: string) => {
  const { isAuthenticated } = useAuth();
  const api = useGrapevineGroupApi();

  return useQuery({
    queryKey: [API_CACHE_KEYS.GROUP_ADMINS, groupId],
    queryFn: () => api.getAllGroupAdminsByGroupId({ groupId }),
    enabled: isAuthenticated
  });
};
